<template>
  <div class="content-tab vlanconfig">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="describe">{{$t('vlan.describe')}}</div>
      <div class="content-item-header">
        <div class="tag-legend">
          <div class="untag">{{$t('vlan.untag')}}</div>
          <div class="tag">{{$t('vlan.tag')}}</div>
        </div>
        <button class="q-button blue-btn-full footer-btn" @click="onActionClick('Add')" :title="$t('add')">{{$t('add')}}</button>
      </div>
      <div class="note">
        <icon-remind class="remind"></icon-remind>
        <span class="title">{{$t('vlan.boundingNote')}}</span>
      </div>
      <div class="group-table">
          <fixed-table class="vlan-table" ref="vlanTable" :data="vlanLists" :use-page="false" :header-height="40">
              <div class="right-header" slot="right-header">
                  <column style="width: 14%;">
                    <div class="title1" :title="$t('vlan.vlanId')">{{$t('vlan.vlanId')}}</div>
                    <div class="slash"></div>
                    <div class="title" :title="$t('overview.portNo')">{{$t('overview.portNo')}}</div>
                  </column>
                  <column class="portNo" :title="num" v-for="num in portNumber" :key="num" :style="{ width: 48/portNumber + '%' }">{{num}}</column>
                  <column class="portNo" :title="$t('lag.groupName') + ' ' + num" v-for="num in lagGroupMap.size" :key="num + lagStartNum" :style="{ width: 30 / lagGroupMap.size + '%' }">{{$t('lag.groupName') + ' ' + num}}</column>
                  <column style="width: 8%;" :title="$t('action')">{{$t('action')}}</column>
              </div>
              <template slot="rows" slot-scope="props" >
                  <div class="link-row" v-if="props.data.key > 0">
                      <row class="right" :props="props">
                          <div class="data" style="width: 14%;">{{props.data.key}}</div>
                          <div class="data portNo" :class="{inGroup: getMember(props.data.val, index), disabled: (props.data.key === '1') ? getDisabledMembers(index) : false}" :title="(props.data.key === '1') ? getDisableTooltips(index) : ''"
                          :style="{ width: 48/portNumber + '%' }" v-for="index in portNumber" :key="index">
                            <div class="q-icon " :class="getTagged(props.data.val, index)" />
                          </div>
                          <div class="data portNo" :class="{inGroup: getMember(props.data.val, index+lagStartNum)}"
                          :style="{ width: 30 / lagGroupMap.size + '%' }" v-for="index in lagGroupMap.size" :key="index+lagStartNum">
                            <div class="q-icon " :class="getTagged(props.data.val, index+lagStartNum)" />
                          </div>
                          <div class="data" style="width: 8%;">
                            <span :title="$t('edit')" class="icon-edit" @click="onActionClick('Edit', props)"></span>
                            <span :title="$t('delete')" class="icon-trashcan delete" :disabled="(props.data.key === '1')" @click="onActionClick('Delete', props)"></span>
                          </div>
                      </row>
                  </div>
              </template>
          </fixed-table>
      </div>
    </div>
    <VlanItem :modalTitle="vlantitle" :selectVlan="selectObject" :tagStatusList="tagStatus" :tagList="tagList" :existNum="existNumber" :vlanList="vlanItemList" :disabledList="disabledList" :lagList="lagList" :onChange="getData"></VlanItem>
    <popup-confirm name="vlan-delete-modal" :dialog-header="$t('vlan.deleteTitle')" :dialog-message="$t('vlan.deleteContent')" type="d" :callback="goDeleteData" icon="w"/>
    <popup-confirm name="vlan-warning-modal" :dialog-header="$t('warning')" :dialog-message="warningMsg" icon="w" :onlyOk=true ></popup-confirm>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import VlanItem from './VlanItem'
import iconRemind from '../assets/svg/ic_system_remind.svg'

export default {
  name: 'vlanconfig',
  components: {
    fixedTable,
    row,
    column,
    VlanItem,
    iconRemind
  },
  data () {
    return {
      vlanLists: null,
      tagList: {},
      vlantitle: '',
      selectObject: {},
      delData: null,
      isShowLoading: false,
      actionType: '',
      selType: 'vlan',
      tagStatus: [],
      isButtonEnable: false,
      isPortTrunk: false,
      warningMsg: '',
      existNumber: [],
      setToVlanone: [],
      vlanItemList: [],
      lagStartIdx: 0,
      disabledList: [],
      lagList: [],
      checkSetStatus: false
    }
  },
  created: async function () {
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    isButtonEnable: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    },
    vlanLists: {
      handler (value) {
        if (value) {
          this.existNumber = []
          value.forEach(element => {
            this.existNumber.push(element.key)
          })
          this.vlanItemList = new Array(JSON.parse(JSON.stringify(value)))
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.setInitial()
  },
  methods: {
    preProcess: function () {
      let me = this
      let temp = JSON.parse(JSON.stringify(me.setToVlanone))
      if (temp.length > 0) {
        temp.forEach((item, index) => {
          if (item < (me.portNumber + 1) && me.portMap.get(item + 1)) {
            me.disabledList.push(item + 1)
            me.setToVlanone.splice(me.setToVlanone.indexOf(item), 1)
          }
        })
        if (me.setToVlanone.length > 0 && !this.checkSetStatus) {
          me.setToVlanOne()
        } else {
          me.isShowLoading = false
          me.$forceUpdate()
        }
      } else {
        me.isShowLoading = false
        me.$forceUpdate()
      }
    },
    getData: async function () {
      let me = this
      let getGroup = false
      this.setInitial()
      this.isShowLoading = true
      await this.getLagStatus()
        .then(res => {
          getGroup = true
          if (res.data && res.data.error_code === 200) {
            let data = []
            res.data.result.forEach(element => {
              if (Number(element.key) <= this.lagGroupMap.size) {
                data.push(element)
              }
            })
            this.lagList = data
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
      if (!getGroup) {
        this.getData()
        return
      }
      this.getVlan()
        .then(async res => {
          if (res.data && res.data.error_code === 200) {
            let detail = res.data.result
            let deleteList = []
            let count = 0
            me.vlanLists = detail
            me.vlanLists.forEach((element, vlanIdx) => {
              if (element.val) {
                element.val.forEach((item, index) => {
                  let port = Number(item.Port)
                  let idx = me.setToVlanone.indexOf(port - 1)
                  if (me.tagStatus[port - 1] === undefined) {
                    me.tagStatus[port - 1] = (item.Tagged) ? 'tag' : 'untag'
                  } else {
                    switch (this.tagStatus[port - 1]) {
                      case 'untag':
                        me.tagStatus[port - 1] = (item.Tagged) ? 'both' : 'untag'
                        break
                      case 'tag':
                        me.tagStatus[port - 1] = (item.Tagged) ? 'tag' : 'both'
                        break
                    }
                  }
                  if (idx > -1) {
                    me.setToVlanone.splice(idx, 1)
                  }
                  if (!me.tagList[port]) {
                    me.tagList[port] = []
                  }
                  if (!item.Tagged) {
                    me.tagList[port][0] = element
                  } else {
                    me.tagList[port][1] = (!me.tagList[port][1]) ? 1 : me.tagList[port][1] + 1
                  }
                })
                this.existNumber.push(element.key)
              } else {
                deleteList.push(element.key)
              }
            })
            if (deleteList.length > 0) {
              deleteList.forEach(async key => {
                await me.delVlan([key])
                count++
                if (count === deleteList.length) {
                  this.getData()
                }
              })
            } else {
              this.preProcess()
            }
          }
        })
        .catch(error => {
          if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
            this.$parent.onLogout()
          } else {
            this.$log.error(error)
          }
        })
    },
    setToVlanOne: function () {
      this.checkSetStatus = true
      this.$log.info('settovlan one')
      var temp = []
      var data = this.vlanLists[0]
      this.setToVlanone.forEach(element => {
        let port = element + 1
        temp.push({
          Port: port.toString(),
          Tagged: false
        })
      })
      this.vlanLists[0].val = data.val.concat(temp)
      this.setVlan({data: [data], action: 'edit'})
        .then((result) => {
          this.getData()
        })
        .catch((error) => {
          this.$log.error(error)
          if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
            this.$parent.onLogout()
          } else {
            this.$log.error(error)
          }
        })
    },
    getDisabledMembers: function (data) {
      if (this.disabledList.indexOf(data) > -1) {
        return true
      } else {
        return false
      }
    },
    getDisableTooltips: function (data) {
      if (this.disabledList.indexOf(data) > -1) {
        return this.$t('lag.alreadyJoin')
      } else {
        return ''
      }
    },
    getMember: function (val, index) {
      let isExsit = false
      if (val) {
        val.forEach(element => {
          if (parseInt(element.Port) === index) {
            isExsit = true
          }
        })
      }
      return isExsit
    },
    getTagged: function (portList, index) {
      let isTagged = null
      if (portList) {
        portList.forEach(element => {
          if (parseInt(element.Port) === index) {
            isTagged = element.Tagged
          }
        })
      }
      if (this.disabledList.indexOf(index) > -1) {
        isTagged = false
      }
      return (isTagged) ? 'tagged' : ''
    },
    onActionClick: function (type, propData) {
      this.actionType = type
      this.selectObject = {}
      if (type === 'Add') {
        this.selectObject = Object.assign({}, this.selectObject, null)
        this.disabledList = Object.assign([], this.disabledList, this.disabledList)
        this.vlantitle = this.$t('vlan.addVlan')
        if (this.vlanLists.length < 4000) {
          this.openModal('vlan-modal')
          this.$modal.show('vlan-modal')
        } else {
          this.warningMsg = this.$t('vlan.addVlanLimit')
          this.openModal('vlan-warning-modal')
          this.$modal.show('vlan-warning-modal')
        }
      } else if (type === 'Edit') {
        this.vlantitle = this.$t('vlan.editVlan')
        this.selectObject = Object.assign({}, this.selectObject, propData.data)
        this.disabledList = Object.assign([], this.disabledList, this.disabledList)
        this.openModal('vlan-modal')
        this.$modal.show('vlan-modal')
      } else if (type === 'Delete') {
        this.openModal('vlan-delete-modal')
        this.$modal.show('vlan-delete-modal')
        this.delData = propData.data
      }
    },
    goDeleteData: function () {
      this.closeModal('vlan-delete-modal')
      this.$modal.hide('vlan-delete-modal')
      this.isShowLoading = true
      this.checkSetStatus = false
      this.delVlan([this.delData.key]).then((res) => {
        this.getData()
      }).catch(error => {
        this.$log.error(error)
        this.isShowLoading = false
        if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
          this.$parent.onLogout()
        } else {
          this.$log.error(error)
        }
      })
    },
    setInitial: function () {
      this.existNumber = []
      this.disabledList = []
      this.tagStatus = []
      this.tagList = {}
      this.selectObject = {}
      this.setToVlanone = []
      for (let idx = 0; idx < this.portNumber + this.lagGroupMap.size; idx++) {
        if (idx > this.portNumber - 1) {
          this.setToVlanone.push(idx + (this.lagStartNum - this.portNumber))
        } else {
          this.setToVlanone.push(idx)
        }
      }
    },
    ...mapActions(['getVlan', 'setVlan', 'delVlan', 'getLagInfo', 'getLagStatus']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum,
      isDataChanged: state => state.app.isDataChanged,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      currentUser: state => state.module.currentUser,
      lagStartNum: state => state.module.lagStartNum
    })
  }
}
</script>

<style lang="scss" scoped deep>
@import '../assets/scss/variables.scss';
@import '../assets/scss/modal.scss';

.content-tab.vlanconfig {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .qweb-column > .qweb-column-title {
    margin-left: 0px;
    display: contents;
  }
  .content-body {
    padding: 10px;
    .group-table {
      margin-top: 10px;
      height: calc(100% - 150px);
      .right-header {
        >.qweb-column:first-child {
          padding: 0px;
        }
        .title, .slash {
          font-family: 'Roboto-M';
        }
        .title {
          position: absolute;
          display: inline-block;
          right: 10px;
          top: -8px;
        }
        .title1 {
          position: absolute;
          left: 2px;
          top: 5px;
          z-index: 1;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 50%;
        }
        .slash {
          position:relative;
          display: inline-block;
          width: 100%;
          height: 100%;
          &:before {
            content: '';
            position:absolute;
            left:0px;
            top:0;
            right:0;
            bottom:0;
            -webkit-clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
            background:#fff;
            padding-left: 5px;
          }
        }
      }
    }
    .tag-legend {
      >div {
        display: inline-block;
        font-size: 12px;
        &.tag {
          margin-left: 10px;
        }
        &.tag::before, &.untag::before {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 5px;
          position: relative;
          color: #ffffff;
          text-align: center;
          vertical-align: middle;
          line-height: 20px;
          // padding-left: 3px;
        }
        &.tag::before {
          content: "T";
          background: #197EC7;
        }
        &.untag::before {
          content: "U";
          background: #A3CBE9;
        }
      }
    }
    .content-item-header {
      padding-top: 10px;
      display: flex;
      justify-content: space-between;
    }
    >.note {
      margin-top: 10px;
      display: flex;
      // justify-content: end;
      font-family: 'Roboto-R';
      font-size: 14px;
      color: #195A87;
      text-align: left;
      line-height: 18px;
      .remind {
        width: 16px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .q-button{
      &.delete {
        margin-left: 7px;
      }
    }
    .qweb-column.portNo {
      text-align: center;
      padding: 0px;
      .host {
        height: 50%;
        line-height: 14px;
      }
    }
    .qweb-column, .data {
      text-overflow: ellipsis;
      /* Required for text-overflow to do anything */
      white-space: nowrap;
      overflow: hidden;
    }
    .data {
      &.portNo {
        padding: 0px !important;
        border: 1px solid #F1F1F1;
        border-top: none;
        border-bottom: none;
        &.isOdd {
          background: #F1F1F1;
        }
        &.inGroup {
          >.q-icon {
            width: 20px;
            height: 20px;
            margin: 9px auto;
            padding-top: 9px;
            &.tagged {
              -webkit-mask-image: none;
              border-radius: 50%;
              background: #197EC7;
              color: #ffffff;
              &::after {
                content: 'T';
                position: relative;
                top: -18px;
                left: 6px;
              }
            }
          }
        }
      }
    }
    .vlan-table {
      position: relative;
      width: 100%;
      overflow: auto;
      .link-row:hover {
        >.data-row {
          background: none;
        }
      }
      .data.inGroup, .data.disabled {
        .q-icon {
          -webkit-mask-image: none;
          border-radius: 50%;
          background: #A3CBE9;
          color: #ffffff;
          &::after {
            content: 'U';
            position: relative;
            top: -18px;
            left: 6px;
          }
        }
      }
      .data.disabled .q-icon {
        width: 20px;
        height: 20px;
        margin: 9px auto;
        padding-top: 9px;
        background: #AEAEAE;
      }
      /deep/ .header {
        display: inline-block;
        width: 100%;
        min-width: 925px;
        overflow: hidden;
        position: absolute;
        .right-header {
          flex: none;
        }
      }
      /deep/ .body {
        position: absolute;
        width: 100%;
        top: 40px;
        .scrollContainer {
          min-width: 924px;
        }
      }
    }
    .content-body-footer {
      position: absolute;
      bottom: 0px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/VLAN.vue